/**
 * [INPUT]: 依赖 React Router declarative mode、AppShell 与四个产品页面
 * [OUTPUT]: 对外提供 AppRouter 稳定路由树
 * [POS]: app 的 URL 事实中心，页面不自行创建嵌套路由边界
 * [PROTOCOL]: 变更时更新此头部，然后检查 AGENTS.md
 */

import { lazy, Suspense } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

import { AppShell } from '@/components/AppShell'
import { LoadingState } from '@/components/States'

const ItemPage = lazy(() =>
  import('@/features/ItemPage').then((module) => ({ default: module.ItemPage })),
)
const LibraryPage = lazy(() =>
  import('@/features/LibraryPage').then((module) => ({ default: module.LibraryPage })),
)
const OfflinePage = lazy(() =>
  import('@/features/OfflinePage').then((module) => ({ default: module.OfflinePage })),
)
const NotFoundPage = lazy(() =>
  import('@/features/NotFoundPage').then((module) => ({ default: module.NotFoundPage })),
)

export function AppRouter() {
  return (
    <BrowserRouter>
      <AppShell>
        <Suspense
          fallback={
            <div className="page">
              <LoadingState />
            </div>
          }
        >
          <Routes>
            <Route path="/" element={<LibraryPage />} />
            <Route path="/items/:id" element={<ItemPage />} />
            <Route path="/offline" element={<OfflinePage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </AppShell>
    </BrowserRouter>
  )
}
